export function toIsoWithOffset(input: string | Date): string {
  const d = typeof input === "string" ? new Date(input) : input;
  // toISOString() → "2025-07-14T00:00:00.000Z"
  // replace Z with +00:00
  return d.toISOString().replace(/\.000Z$/, "+00:00");
}
